<template>
  <div class="news-container">
    <Header ref="Headers" />

    <CategoryView 
      categoryId="502"
      ref="categoryView"
    >
      <!-- 自定义tabs UI -->
      <template #tabs="{ category, onChange }">
        <div class="sub-tabs">
          <div 
            v-for="(subCategory, subIndex) in category.children" 
            :key="subIndex"
            :class="['sub-tab', { active: category.activeTab === subIndex }]"
            @click="onChange(category, subIndex)"
          >
            {{ subCategory.categoryName }}
          </div>
        </div>
        <div v-for="(subCategory, subIndex) in category.children" :key="subIndex" v-show="category.activeTab === subIndex">
          <div v-if="subCategory.articles && subCategory.articles.length > 0">
            <List :is-show-time="true" :data="subCategory.articles" />
          </div>
          <div v-else class="empty-tip">暂无数据</div>
        </div>
      </template>
    </CategoryView>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/footer.vue";
import Header from "@/components/header.vue";
import CategoryView from "@/components/CategoryView.vue";
import List from "@/components/list.vue";

export default {
  components: {
    List,
    CategoryView,
    Header,
    Footer
  },
  activated() {
    this.$refs.Headers.switchTab(3);
    // 分类组件内部会自动加载数据
  }
};
</script>

<style scoped lang="scss">
// 主容器样式
.news-container {
  background: #ffffff;
  position: relative;
  min-height: 100vh;
}

// CSS变量用于主题定制
:deep(.category-view) {
  --theme-color: #ee0a24;
}

// 子分类标签样式
.sub-tabs {
  display: flex;
  margin-top: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
  
  .sub-tab {
    font-size: 30px;
    font-weight: bold;
    color: #666;
    margin-right: 30px;
    padding: 0 10px;
    cursor: pointer;
    position: relative;
    
    &.active {
      color: #ee0a24;
      
      &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: -11px;
        height: 3px;
        background-color: #ee0a24;
      }
    }
  }
}

// 空状态提示
.empty-tip {
  font-size: 28px;
  line-height: 40px;
  text-align: center;
  color: #999;
  padding: 30px 0;
}
</style>